const sendHttpGetRequest = (url) => {
  return fetch(url).then((response) => {
    if (response.status >= 400) {      
      return response.json().then((errResData) => {
        const error = new Error(`Something went wrong! ${errResData}`);
        error.data = errResData;
        throw error;
      });
    }
    return response.json().then((data) => data);
  });
};

export default sendHttpGetRequest;
